<template>
  <b-form-group
    label="Ödeme Şekli"
    label-for="payment_type"
  >
    <validation-provider
      #default="{ errors }"
      name="Ödeme Şekli"
      rules="required"
    >
      <b-form-input
        id="payment_type"
        v-model="dataItem.payment_type"
        placeholder="Ödeme Şekli"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'PaymentType',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['proformaInvoices/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
